import { defineComponent as i, computed as b, ref as u } from "vue";
import { E as v, a as h } from "../const-CZJ2cQu8.js";
import { D as m } from "../DIcon-Jms8BmCS.js";
import "../useHammerSwipe-DqcYRvhM.js";
import { u as k } from "../useModel-IfHLT9OI.js";
import "../_baseClone-CPYgn-G_.js";
import { n as f } from "../index.browser-CWCjzKuA.js";
import { n as g } from "../_plugin-vue2_normalizer-WQT2Fc8L.js";
import '../assets/DCheckbox-Dt4Hmtog.css';var x = /* @__PURE__ */ ((o) => (o.LARGE = "large", o.SMALL = "small", o))(x || {}), l = /* @__PURE__ */ ((o) => (o.GREEN_223 = "green-223", o.EMERALD_312 = "emerald-312", o.ORANGE_198 = "orange-198", o))(l || {}), d = /* @__PURE__ */ ((o) => (o.CHECK = "check/check", o.MINUS = "check/minus", o))(d || {});
const y = i({
  components: {
    DIcon: m
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    id: { type: String, default: () => f() },
    color: { type: String, default: () => l.GREEN_223 },
    block: { type: Boolean },
    dark: { type: Boolean },
    modelValue: { type: Boolean },
    icon: { type: String, default: () => d.CHECK },
    disabled: Boolean,
    error: Boolean,
    tabindex: { type: Number, default: 0 },
    name: { type: String, default: "" }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: e }) {
    const c = k(o, "modelValue", e), r = {
      default: {
        "--outline-color_error": "var(--d-color-red-241)",
        "--color_disabled": "var(--d-color-grey-284)",
        "--bg_error": "var(--d-color-red-241)"
      },
      lightDefault: {
        "--outline-color_disabled": "var(--d-color-grey-166)",
        "--bg_disabled": "var(--d-color-grey-114)",
        "--outline-color_iddle": "var(--d-color-grey-166)",
        "--bg_iddle": "var(--d-color-white-101)",
        "--outline-color_hover": "var(--d-color-grey-1514)",
        "--bg_hover": "var(--d-color-white-101)",
        "--color_iddle": "var(--d-color-grey-1514)"
      },
      darkDefault: {
        "--outline-color_disabled": "var(--d-color-grey-114)",
        "--bg_disabled": "var(--d-color-grey-166)",
        "--outline-color_iddle": "var(--d-color-grey-517)",
        "--bg_iddle": "var(--d-color-grey-868)",
        "--outline-color_hover": "var(--d-color-grey-166)",
        "--bg_hover": "var(--d-color-grey-868)",
        "--color_iddle": "var(--d-color-white-101)"
      }
    }, t = {
      [l.GREEN_223]: {
        "--outline-color_active": "var(--d-color-green-223)",
        "--bg_active": "var(--d-color-green-223)",
        "--outline-color_active_hover": "var(--d-color-green-333)",
        "--bg_active_hover": "var(--d-color-green-333)"
      },
      [l.EMERALD_312]: {
        "--outline-color_active": "var(--d-color-emerald-312)",
        "--bg_active": "var(--d-color-emerald-312)",
        "--outline-color_active_hover": "var(--d-color-emerald-439)",
        "--bg_active_hover": "var(--d-color-emerald-439)"
      },
      [l.ORANGE_198]: {
        "--outline-color_active": "var(--d-color-orange-198)",
        "--bg_active": "var(--d-color-orange-198)",
        "--outline-color_active_hover": "var(--d-color-orange-23)",
        "--bg_active_hover": "var(--d-color-orange-23)"
      }
    }, _ = b(() => ({
      display: o.block ? "block" : "inline-block",
      ...r.default,
      ...o.dark ? r.darkDefault : r.lightDefault,
      ...t[o.color]
    })), n = () => {
      o.disabled || (c.value = !c.value);
    }, s = u(!1);
    return {
      style: _,
      localValue: c,
      EIconSize: v,
      EIconColor: h,
      EColor: l,
      onToggle: n,
      isFocused: s
    };
  }
}), p = {
  "d-checkbox": "_d-checkbox_m4fn2_1",
  "d-checkbox__controller": "_d-checkbox__controller_m4fn2_10",
  "d-checkbox__label": "_d-checkbox__label_m4fn2_21",
  "d-checkbox__icon": "_d-checkbox__icon_m4fn2_26",
  "d-checkbox_focused": "_d-checkbox_focused_m4fn2_34",
  "d-checkbox_active": "_d-checkbox_active_m4fn2_38",
  "d-checkbox_error": "_d-checkbox_error_m4fn2_46",
  "d-checkbox_disabled": "_d-checkbox_disabled_m4fn2_55",
  "d-checkbox__messages": "_d-checkbox__messages_m4fn2_60",
  "d-checkbox__box": "_d-checkbox__box_m4fn2_66",
  "d-checkbox__input": "_d-checkbox__input_m4fn2_81"
};
var E = function() {
  var e = this, c = e._self._c;
  return e._self._setupProxy, c("div", { class: {
    [e.$style["d-checkbox"]]: !0,
    [e.$style["d-checkbox_dark"]]: e.dark,
    [e.$style["d-checkbox_error"]]: e.error,
    [e.$style["d-checkbox_active"]]: e.localValue,
    [e.$style["d-checkbox_focused"]]: e.isFocused,
    [e.$style["d-checkbox_disabled"]]: e.disabled,
    [e.$style["d-checkbox_color-green"]]: e.color === e.EColor.GREEN_223,
    [e.$style["d-checkbox_color-emerald"]]: e.color === e.EColor.EMERALD_312,
    [e.$style["d-checkbox_color-orange"]]: e.color === e.EColor.ORANGE_198
  }, style: e.style }, [c("label", { class: {
    [e.$style["d-checkbox__controller"]]: !0
  }, attrs: { disabled: e.disabled, tabindex: e.tabindex, role: "checkbox", for: e.id }, on: { click: e.onToggle, keydown: function(r) {
    return !r.type.indexOf("key") && e._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.preventDefault(), e.onToggle.apply(null, arguments));
  }, focus: function(r) {
    e.isFocused = !0;
  }, blur: function(r) {
    e.isFocused = !1;
  } } }, [c("div", { class: e.$style["d-checkbox__box"] }, [c("DIcon", { class: {
    [e.$style["d-checkbox__icon"]]: !0
  }, style: {
    opacity: e.localValue ? "1" : "0",
    transform: e.localValue ? "scale(1)" : "scale(.8)"
  }, attrs: { name: e.icon, size: e.EIconSize.S_16, color: !e.dark && e.disabled ? e.EIconColor.GREY_166 : e.EIconColor.WHITE_101, bold: "", block: "" } })], 1), c("input", { class: e.$style["d-checkbox__input"], attrs: { id: e.id, name: e.name, type: "checkbox", disabled: e.disabled, tabindex: "-1" }, domProps: { checked: e.localValue }, on: { click: function(r) {
    r.stopPropagation();
  } } }), c("div", { class: e.$style["d-checkbox__label"] }, [e._t("default")], 2)]), e.$slots.messages && !e.disabled ? c("div", { class: e.$style["d-checkbox__messages"] }, [e._t("messages")], 2) : e._e()]);
}, $ = [];
const a = {
  $style: p
};
function C(o) {
  for (var e in a)
    this[e] = a[e];
}
var D = /* @__PURE__ */ g(
  y,
  E,
  $,
  !1,
  C
);
const B = D.exports;
export {
  B as DCheckbox,
  l as EColor,
  d as EIcon,
  x as ESize
};
